<template>
  <el-dialog
    title="应用楼层记录"
    :visible.sync="visible"
    append-to-body
    :close-on-click-modal="false"
    width="1400px"
    @close="selectElevatorDialogClose"
  >
    <div class="admin-project-myproject-container">
      <el-form
        ref="elevatorSearch"
        :inline="true"
        :model="selectElevatorSearch"
        class="demo-form-inline"
      >
        <el-form-item label="电梯名称">
          <el-input
            v-model="selectElevatorSearch.name"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="电梯注册代码">
          <el-input
            v-model="selectElevatorSearch.code"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="searchElevator"
            class="searchBtn"
          >搜索</el-button>
          <el-button
            type="warning"
            @click="reset"
          >重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="selectElevatorList"
        :data="selectElevatorList"
        border
        stripe
        fit
        highlight-current-row
        :select-on-indeterminate="false"
        max-height="500px"
        row-key="id"
        @select="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          label-class-name="DisabledSelection"
          reserve-selection
          width="55px"
          align="center"
        />
        <el-table-column
          label="序号"
          type="index"
          width="50px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              (selectElevatorListQuery.current - 1) *
                selectElevatorListQuery.size +
              scope.$index +
              1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="电梯名称"
          min-width="150px"
        />
        <el-table-column
          align="center"
          prop="code"
          label="电梯注册代码"
          min-width="120px"
        />
        <el-table-column
          align="center"
          prop="deviceCode"
          label="AI摄像头ID"
          min-width="120px"
        />
        <el-table-column
          align="center"
          prop="rescueCode"
          label="救援识别码"
          min-width="120px"
        />
        <el-table-column
          align="center"
          prop="maintainUnitName"
          label="维保单位"
          min-width="150px"
        />
        <el-table-column
          align="center"
          prop="propertyUnitName"
          label="物业单位"
          min-width="120px"
        />
        <el-table-column
          align="center"
          prop="createUserName"
          label="创建人"
          min-width="120px"
        />
      </el-table>
      <Pagination
        v-show="selectElevatorListTotal > 0"
        :total="selectElevatorListTotal"
        :page.sync="selectElevatorListQuery.current"
        :limit.sync="selectElevatorListQuery.size"
        @pagination="selectElevatorListGet"
      />
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        type="primary"
        @click="selectElevatorConfirm"
      >确 定</el-button>
      <el-button
        size="small"
        @click="visible = false"
      >取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { set } from 'vue'
import Pagination from '../../../../components/Pagination'

export default {
  components: {
    Pagination,
  },

  data() {
    return {
      visible: false,
      loading: true,
      selectElevatorListQuery: {
        current: 1,
        size: 100,
      },
      selectElevatorSearch: {
        name: '',
        code: '',
      },
      selectElevatorList: [],
      selectElevatorListTotal: 0,
      selectElevatorCallback: null,
      selectRow: {},
      elevatorId: [],
      selectData: [],
      initArr: [],
      updateArr: [],
    }
  },
  methods: {
    init(callback) {
      this.selectElevatorCallback = callback
      this.visible = true
      this.loading = false
      this.selectElevatorListQuery = {
        current: 1,
        size: 10,
      }
      this.$nextTick(() => {
        this.selectElevatorListGet()
      })
    },

    handleSelectionChange(val, row) {
      this.initArr = row
      this.selectElevatorList.forEach(item => {
        if (val[val.length - 1] === item) {
          this.$refs.selectElevatorList.toggleRowSelection(item, true)
        } else {
          this.$refs.selectElevatorList.toggleRowSelection(item, false)
        }
      })
    },

    selectElevatorListGet() {
      const params = this.selectElevatorListQuery
      params.name = this.selectElevatorSearch.name
      params.code = this.selectElevatorSearch.code
      this.loading = true
      this.$http.post('/api/ele/web/elevatorInfo/list', params).then((res) => {
        if (res.data.success) {
          const {
            data: { data },
          } = res
          this.loading = false
          this.selectElevatorList = data.records ?? []
          this.selectElevatorListTotal = data.total ?? 0
          
          this.$nextTick(() => {
            if (this.selectElevatorListTotal > 0 && this.$refs.selectElevatorList) {
              this.$refs.selectElevatorList.bodyWrapper.scrollTop = 0;
            }
          })
        }
      })
    },
    // 搜索
    searchElevator() {
      this.selectElevatorListQuery.current = 1
      this.selectElevatorListGet()
    },

    // 重置
    reset() {
      this.selectElevatorListQuery = {
        current: 1,
        size: 10,
      }
      this.selectElevatorSearch.name = ''
      this.selectElevatorSearch.code = ''
      this.selectElevatorListGet()
    },

    selectElevatorConfirm() {
      // console.log(this.initArr, 'this.initArr');
      if (this.initArr.length == 0) {
        this.$message.error('请选择应用楼层记录');
        return
      }
      console.log(this.initArr, 'this.initArr');
      const elevatorData = this.initArr
      this.visible = false
      this.$emit('transferElevator', elevatorData)
    },

    selectElevatorDialogClose() {
      this.selectElevatorListQuery.current = 1
      this.$refs.selectElevatorList.setCurrentRow()
      this.$refs.selectElevatorList.clearSelection()
      this.$emit('changeElevatorDialog')
    },
  },
}
</script>
<style lang="scss" scoped>
/*表格全选框去除空框*/

/deep/.el-table__header-wrapper .el-checkbox {
  display: none;
  position: relative;
}
</style>
